module.exports = __webpack_public_path__ + "static/media/loader.ff07297e.svg";